import React, { useState } from 'react';
import axiosInstance from '../api/axiosConfig';
import { useNavigate } from 'react-router-dom';

const CreateCompany = () => {
  const [name, setName] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post('/company/create', { name });
      navigate('/dashboard'); // Redirige vers le tableau de bord après la création
    } catch (error) {
      console.error('Failed to create company', error);
    }
  };

  return (
    <div>
      <h2>Créer mon entreprise</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nom de l'entreprise"
        />
        <button type="submit">Créer</button>
      </form>
    </div>
  );
};

export default CreateCompany;